export default __webpack_public_path__ + "static/media/user2.3f552a80.png";